module.exports = __webpack_public_path__ + "img/certificate02-1-6.5fba8458.jpg";